var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bet-radar-widget" },
    [
      _vm._v("\n  " + _vm._s(_vm.messageFunc()) + "\n  "),
      !_vm.isBiggerScreen
        ? [
            _c("iframe", {
              staticClass: "frame",
              attrs: {
                src:
                  _vm.iframe.srcPreMatch +
                  "?id=" +
                  _vm.betRadarId +
                  "&mobile=" +
                  _vm.isBigger +
                  "&isLive=" +
                  _vm.isLive,
                width: _vm.calculatedWith,
                frameborder: "0",
                id: "iframe"
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isBiggerScreen
        ? [
            _c("iframe", {
              staticClass: "frame",
              attrs: {
                src:
                  _vm.iframe.srcInMatch +
                  "?id=" +
                  _vm.betRadarId +
                  "&mobile=" +
                  _vm.isBigger +
                  "&isLive=" +
                  _vm.isLive,
                scrolling: _vm.iframe.style.scrolling,
                width: _vm.calculatedWith,
                frameborder: "0",
                id: "iframe"
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24ea01aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ea01aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/betRadarWidget.vue
// module id = null
// module chunks = 